module.exports = require("core-js/library/fn/set");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/set.js